import { useRef } from "react";
import { Select } from "antd";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { TIMEZONE } from "../../_components/Candidate/EditCandidateProfile/constants";

export const TimezoneSearchInput = ({
  searchStyle,
  placeholder,
  onSearchSelect,
  clearSearch,
  defaultTimezoneValue,
  dropdownStyle,
  isDisabled,
}) => {
  const [timezoneData, setTimezoneData] = useState([]);
  const [loading, setLoading] = useState();
  const [searchValue, setSearchValue] = useState(null);

  const ref = useRef();
  useEffect(() => {
    if (ref?.current && ref?.current?.value) {
      ref.current.value = defaultTimezoneValue;
    }
  }, [defaultTimezoneValue]);

  useEffect(() => {
    setTimezoneData(TIMEZONE);
  }, []);

  const handleSearch = async (newValue) => {
    setSearchValue(newValue);
    setLoading(true);
    if (newValue.length > 1) {
      const filteredData = TIMEZONE.filter(
        (item) =>
          item.value &&
          item.value.toLowerCase().includes(newValue.toLowerCase())
      );
      setTimezoneData(filteredData);
    } else {
      setTimezoneData(TIMEZONE);
    }
    setLoading(false);
  };

  const handleChange = (newValue) => {
    if (newValue) onSearchSelect(newValue);
    setTimezoneData([]);
    if (clearSearch) {
      setSearchValue(null);
    }
  };
  return (
    <Select
      ref={ref}
      showSearch
      value={defaultTimezoneValue}
      className="col-lg-12 px-0 position-relative h-auto"
      searchValue={searchValue}
      placeholder={placeholder}
      style={searchStyle}
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      allowClear={true}
      dropdownStyle={dropdownStyle}
      disabled={isDisabled}
      notFoundContent={
        loading ? (
          <Spinner animation="grow" variant="primary" size={"sm"} />
        ) : searchValue && searchValue.length > 0 ? (
          !clearSearch ? (
            <p>No timezone found</p>
          ) : (
            <p
              onClick={() => handleChange(searchValue)}
              className="text-primary"
            >
              Add "{searchValue}"
            </p>
          )
        ) : null
      }
      options={
        Array.isArray(timezoneData) &&
        timezoneData.map((d) => ({
          value: d?.key,
          label: d?.key,
        }))
      }
      getPopupContainer={(trigger) => trigger.parentNode}
    />
  );
};
